import { useState } from "react";
import axios from "axios";
import { Table, Card, Form, Row, Col } from "react-bootstrap";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

const API_URL = process.env.REACT_APP_API_URL;

interface Contacto {
  identificacion: string;
  nombre_completo: string;
  telefono: string;
  provincia_home: string;
  canton_home: string;
  latitude_home: number;
  longitude_home: number;
  provincia_work: string;
  canton_work: string;
  latitude_work: number;
  longitude_work: number;
}

export default function ContactsGeolocationPage() {
  const [identificacion, setIdentificacion] = useState("");
  const [telefono, setTelefono] = useState("");
  const [nombre, setNombre] = useState("");
  const [resultados, setResultados] = useState<Contacto[]>([]);
  const [seleccionado, setSeleccionado] = useState<Contacto | null>(null);
  const [loading, setLoading] = useState(false);

  const buscar = async () => {
    setLoading(true);
    setResultados([]);
    setSeleccionado(null);

    const res = await axios.get<Contacto[]>(`${API_URL}/localizacion/buscar_contactos`, {
      params: {
        identificacion: identificacion || null,
        telefono: telefono || null,
        nombre: nombre || null
      }
    });
    setResultados(res.data);
    setLoading(false);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      buscar();
    }
  };

    const limpiarFiltros = () => {
    setIdentificacion("");
    setTelefono("");
    setNombre("");
    setResultados([]);
    setSeleccionado(null);
    };

    L.Icon.Default.mergeOptions({
    iconRetinaUrl: markerIcon2x,
    iconUrl: markerIcon,
    shadowUrl: markerShadow,
    });

    const iconCasa = new L.Icon({
    iconUrl: "https://cdn-icons-png.flaticon.com/512/25/25694.png",
    iconSize: [32, 32],
    iconAnchor: [16, 32],
    popupAnchor: [0, -32]
    });

    const iconTrabajo = new L.Icon({
    iconUrl: "https://cdn-icons-png.flaticon.com/512/141/141927.png",
    iconSize: [32, 32],
    iconAnchor: [16, 32],
    popupAnchor: [0, -32]
    });

  return (
    <div>
      <h2 className="mb-4">Localización de Contactos</h2>

      {/* Filtros */}
      <Card className="mb-4">
        <Card.Body>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>Identificación</Form.Label>
                <Form.Control
                  value={identificacion}
                  onChange={(e) => setIdentificacion(e.target.value)}
                  onKeyDown={handleKeyDown}
                />
              </Form.Group>
            </Col>

            <Col>
              <Form.Group>
                <Form.Label>Teléfono</Form.Label>
                <Form.Control
                  value={telefono}
                  onChange={(e) => setTelefono(e.target.value)}
                  onKeyDown={handleKeyDown}
                />
              </Form.Group>
            </Col>

            <Col>
              <Form.Group>
                <Form.Label>Nombre</Form.Label>
                <Form.Control
                  value={nombre}
                  onChange={(e) => setNombre(e.target.value)}
                  onKeyDown={handleKeyDown}
                />
              </Form.Group>
            </Col>
            {/* 
            <Col xs="auto" className="d-flex align-items-end">
              <button className="btn btn-primary" onClick={buscar}>
                Buscar
              </button>
            </Col>
            */}
            <Col xs="auto" className="d-flex align-items-end">
            <button className="btn btn-secondary" onClick={limpiarFiltros}>
                Limpiar
            </button>
            </Col>            
          </Row>
        </Card.Body>
      </Card>

      {loading && <div className="text-center my-3">Cargando...</div>}

      {/* Tabla */}
      <Card>
        <Card.Header><strong>Resultados</strong></Card.Header>
        <Table striped bordered hover>          
          <thead>
            <tr>
              <th>Identificación</th>
              <th>Nombre completo</th>
              <th>Teléfono</th>
              <th>Ubicación Casa</th>
              <th>Coordenadas Casa</th>
              <th>Ubicación Trabajo</th>
              <th>Coordenadas Trabajo</th>
            </tr>
          </thead>
          <tbody>            
            {resultados.map((c) => (
              <tr key={c.identificacion} onClick={() => setSeleccionado(c)} style={{ cursor: "pointer" }}>
                <td>{c.identificacion}</td>
                <td>{c.nombre_completo}</td>
                <td>{c.telefono}</td>
                <td>{c.provincia_home}, {c.canton_home}</td>
                <td>{c.latitude_home}, {c.longitude_home}</td>
                <td>{c.provincia_work}, {c.canton_work}</td>
                <td>{c.latitude_work}, {c.longitude_work}</td>
              </tr>
            ))}
          </tbody>
        </Table>
        {!loading && resultados.length === 0 && (
        <div className="text-center py-3 text-muted">
          No se encontraron resultados
        </div>
        )}
      </Card>

      {/* Mapa */}
      {seleccionado && (
        <Card className="mt-4">
          <Card.Header><strong>Mapa de Ubicaciones</strong></Card.Header>
          <Card.Body>
            <MapContainer
              key={seleccionado.identificacion + seleccionado.telefono}
              center={[seleccionado.latitude_home, seleccionado.longitude_home]}
              zoom={12}
              style={{ height: "400px", width: "100%" }}
            >
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

              {/* Casa */}              
              <Marker 
                position={[seleccionado.latitude_home, seleccionado.longitude_home]}
                icon={iconCasa}
                >
                <Popup>
                  <strong>Casa</strong><br />
                  {seleccionado.provincia_home}, {seleccionado.canton_home}
                </Popup>
              </Marker>              
              {/* Trabajo */}              
              <Marker 
                position={[seleccionado.latitude_work, seleccionado.longitude_work]}
                icon={iconTrabajo}
                >
                <Popup>
                  <strong>Trabajo</strong><br />
                  {seleccionado.provincia_work}, {seleccionado.canton_work}
                </Popup>
              </Marker>
            </MapContainer>
          </Card.Body>
        </Card>
      )}
    </div>
  );
}